import { render, staticRenderFns } from "./TheEmpty.vue?vue&type=template&id=684937c6"
import script from "./TheEmpty.vue?vue&type=script&lang=js"
export * from "./TheEmpty.vue?vue&type=script&lang=js"
import style0 from "./TheEmpty.vue?vue&type=style&index=0&id=684937c6&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports